import { getStage, Stage } from 'src/components/common/util/StageHelpers';

export const getBaseBindleUrl = () =>
  `https://bindles${getStage() === Stage.Prod ? '' : '-gamma'}.amazon.com`;
